var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('FlashMessages'),_vm._v(" "),_c('router-view',{key:_vm.routeKey})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }